/**
 * ImageGallery JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

// Use modaal for the accessible image gallery
import 'modaal';
import 'wicg-inert/dist/inert.min.js';

/**
 * Class ImageGallery
 */
class ImageGallery {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {}

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {}

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get all gallery-elements.
        this.$galleries = $( '.js-image-gallery' );

        // Get all gallery-elements.
        this.$galleryItems = $( '.js-image-gallery__item' );
    }

    /**
     * Init all found galleries.
     */
    initGalleries() {

        if ( this.$galleries.length > 0 ) {

            // Go through each gallery and its thumbnail to add them to a data group to separate
            // different galleries on one page
            this.$galleries.each( ( index, gallery ) => {

                // Create an aria description div inside of the first gallery - used in all
                // galleries on the same page
                if ( index == 0 ) {

                    $( gallery ).before( '<div id="aria-gallery-description" class="u-sr-only">' + themeData.themeStrings.image_gallery.gallery_aria_tooltip + '</div>' );
                }

                // Get current gallery's items
                const $galleryItems = $( gallery ).find( '.js-image-gallery__item' );

                // Set an aria description to the image
                $galleryItems.attr( 'aria-describedby', 'aria-gallery-description' );

                // Add the data group index to every link
                $galleryItems.attr( 'data-group', index );
            });

            // Global settings for all gallery items
            this.$galleryItems.each( ( index, galleryItem ) => {

                // Get the alt text
                const imageCaption = $( galleryItem ).data( 'accessible-title' );

                // Set the description
                $( galleryItem ).attr( 'data-modaal-desc', imageCaption );

                // Init Modaal for each gallery item
                $( galleryItem ).modaal({
                    type: 'image',
                    background_scroll: false,                                                    //eslint-disable-line
                    close_aria_label: themeData.themeStrings.image_gallery.gallery_close_string, //eslint-disable-line
                    close_text: themeData.themeStrings.image_gallery.gallery_close_string,       //eslint-disable-line
                    after_open: this.disableBackgroundItemFocusing,                              //eslint-disable-line
                    before_close: this.setInertToFalse,                                          //eslint-disable-line
                    overlay_opacity: 0.9                                                         //eslint-disable-line
                });
            });
        }
    }

    /**
     * A function to make all the items unfocusable except the opened lightbox gallery
     */
    disableBackgroundItemFocusing( ) {

        // Check the body if modaal-noscroll class is dynamically added, meaning that the gallery is open.
        if ( $( 'body' ).hasClass( 'modaal-noscroll' ) ) {

            // Not cached for the .modaal-wrapper is generated dynamically, and to make sure we get every item here
            const allContainers = $( 'body' ).children().not( '.modaal-wrapper' );

            // Set inert to true on all the containers outside of the modaal-wrapper
            allContainers.each( ( index, item ) => {

                // Small timeout to make sure this applies to everything - without timeout this won't work
                window.setTimeout( item.inert = true, 100 );
            });
        }
    }

    /**
     * Set inert to false on all items, used after closing the lightbox gallery - this makes the items
     * focusable again.
     */
    setInertToFalse() {

        // Not cached, to make sure we have everything
        const allContainers = $( 'body' ).children().not( '.modaal-wrapper' );

        // Set inert to true on all the containers outside of the modaal-wrapper
        allContainers.each( ( index, item ) => {

            item.inert = false;
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.initGalleries();
    }
}

// Export the class reference.
module.exports = ImageGallery;



// WEBPACK FOOTER //
// ./assets/scripts/image-gallery.js